import { until } from "@vueuse/core";

import { watch } from "vue";

import { useRolesManager } from "@/stores/roles-store";

import { RoleEntity } from ".";
import { BaseLinkedEntitiesManager } from "../mystekz-linked-entities/manager";

export class RolesManager extends BaseLinkedEntitiesManager<RoleEntity> {
    nodeType = "role" as const;

    constructor(baseUrl: string) {
        const { roles, isLoading } = useRolesManager();

        super(baseUrl);
        this.events = new EventTarget();
        this.ready = until(isLoading).not.toBeTruthy();

        watch(
            roles,
            async (newValue) => {
                if (newValue) {
                    this.setEntities(newValue);
                }
            },
            { immediate: true }
        );
    }
}
